import {
  ClockStopwatch,
  Clock,
  GitBranch01,
  Hand,
  LogOut01,
  Mail01,
  MessageSquare01,
  Stars01,
  Tool01,
} from "@opendate-app/setlist";

export const NODE_ICONS = {
  "WorkflowNodes::TriggerNode": Stars01,
  "WorkflowNodes::EmailNode": Mail01,
  "WorkflowNodes::SmsNode": MessageSquare01,
  "WorkflowNodes::ManualSegmentUpdateNode": Tool01,
  "WorkflowNodes::TimeDelayNode": ClockStopwatch,
  "WorkflowNodes::SendBetweenNode": Clock,
  "WorkflowNodes::WaitUntilNode": Hand,
  "WorkflowNodes::TrueFalseBranchNode": GitBranch01,
  "WorkflowNodes::ExitNode": LogOut01,
};
